module.exports = __webpack_public_path__ + "static/media/3DPPA5.91e11cec.jpg";